import { chromatographyMnemonics } from 'constants/mnemonics';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { MnemonicsMappingDTO } from 'types/mnemonicsMapping';

import styles from './ChromatographyCheck.module.scss';

interface Props {
  mnemonicsMapping?: MnemonicsMappingDTO;
}

const ChromatographyCheck: React.FC<Props> = ({ mnemonicsMapping }) => {
  return (
    <div>
      <div className={styles.title}>
        <FormattedMessage id="dataManagement.dataQuality.dataConsistency.chromatography" />
      </div>
      <div className={styles.gasMnemonics}>
        {chromatographyMnemonics.map(gasMnemonic => (
          <div
            key={gasMnemonic.mnemonic}
            className={
              mnemonicsMapping?.timeData?.[gasMnemonic.mnemonic]?.live ? styles.green : styles.red
            }
          >
            {gasMnemonic.label}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChromatographyCheck;
